import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import React, { useMemo } from "react";
import { styled } from "@iventis/styles";

export const ReadonlyToolTipComponent = ({ resource }: { resource: "layer" | "map" | "selection" }) => {
    const translate = useIventisTranslate();
    const resourceText = useMemo(() => {
        switch (resource) {
            case "layer":
                return translate(Content.map5.permissions.layer);
            case "map":
                return translate(Content.map5.permissions.map);
            case "selection":
                return translate(Content.map5.permissions.selection);
            default:
                throw new Error("Resource is not handled");
        }
    }, [resource, translate]);

    return (
        <ReadonlyToolTipContainer>
            <FontAwesomeIcon icon="pencil-slash" />
            <span>
                {translate(Content.map5.permissions.permission_is)} <span style={{ fontWeight: 600 }}>{translate(Content.map10.permissions.viewOnly)}</span> {resourceText}
            </span>
        </ReadonlyToolTipContainer>
    );
};

const ReadonlyToolTipContainer = styled.div`
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
`;
